export class GalleryViewer{
    #viewer = null;
    #imageList = [];
    #isShow = false
    static VIEWERS = [];

    get viewer(){
        return this.#viewer
    }

    constructor(parentElem){
        this.#viewer = parentElem
        if(!this.#viewer.classList.contains('g-viewer')){
            throw new Error('Gallery Viewer parent element must have .g-viewer class!');
        }
        const images = this.#viewer.querySelectorAll('.g-viewer-preview img')
        for(const image of images){
            this.#imageList.push(image.getAttribute('src'))
        }
        const preview = this.#viewer.querySelector('.g-viewer-preview')
        let selector = this.#viewer.querySelector('.g-viewer-selector')
        if(!selector){
            selector = document.createElement('div')
            selector.classList.add('g-viewer-selector')
            preview.after(selector)
        }
        for(let imgSrc of this.#imageList){
            const item = document.createElement('div')
            item.classList.add('g-viewer-selector-item')
            const img = document.createElement('img')
            img.setAttribute('src', imgSrc)
            item.append(img)
            selector.append(item)
            item.addEventListener('click', this.selectImage.bind(this))
        }
        const btns = this.#viewer.getElementsByClassName('g-viewer-control-btn')
        for(const btn of btns){
            btn.addEventListener('click', this.selectImage.bind(this))
        }
        document.addEventListener('keydown',(ev)=>{
            if(!this.#isShow) return
            if(ev.code == 'KeyA' || ev.code == 'ArrowLeft'){
                let trigger = new Event('click')
                this.#viewer.querySelector('.g-viewer-prev-btn').dispatchEvent(trigger)
            }else if(ev.code == 'KeyD' || ev.code == 'ArrowRight'){
                let trigger = new Event('click')
                this.#viewer.querySelector('.g-viewer-next-btn').dispatchEvent(trigger)
            }
        })
        const closeBtn = this.#viewer.querySelector('.g-viewer-close-btn')
        closeBtn.addEventListener('click', this.hide.bind(this))
    }

    show(imageSrc=null){
        this.cleanActive()
        if(!imageSrc){
            let activeImage = this.#viewer.querySelector(`.g-viewer-preview img`)
            let activeItem = this.#viewer.querySelector(`.g-viewer-selector-item`)
            activeImage.classList.add('active')
            activeItem.classList.add('active')
        }else{
            this.selectImage(null, imageSrc)
        }
        this.#viewer.classList.add('showed-z')
        this.#viewer.classList.add('showed')
        this.#isShow = true
    }

    hide(){
        this.#viewer.classList.remove('showed-z')
        this.#viewer.classList.remove('showed')
        this.#isShow = false
    }

    selectImage(ev, imageSrc=null){
        let activeImage, activeItem
        if(ev?.currentTarget){
            let btn = ev.currentTarget
            if (btn.classList.contains('g-viewer-selector-item')) {
                let image = btn.querySelector('img')
                let imgSrc = image.getAttribute('src')
                activeImage = this.#viewer.querySelector(`.g-viewer-preview img[src="${imgSrc}"]`)
                activeItem = this.#viewer.querySelector(`.g-viewer-selector-item img[src="${imgSrc}"]`).parentElement
            } else if (btn.classList.contains('g-viewer-prev-btn') || btn.classList.contains('g-viewer-next-btn')) {
                let curActiveImg = this.#viewer.querySelector('.g-viewer-preview img.active')
                let curActiveItem = this.#viewer.querySelector('.g-viewer-selector-item.active')
                if (btn.classList.contains('g-viewer-prev-btn')) {
                    activeImage = curActiveImg.previousElementSibling
                    activeItem = curActiveItem.previousElementSibling
                } else {
                    activeImage = curActiveImg.nextElementSibling
                    activeItem = curActiveItem.nextElementSibling
                }
            }
        }else if(imageSrc){
            activeImage = this.#viewer.querySelector(`.g-viewer-preview img[src="${imageSrc}"]`)
            activeItem = this.#viewer.querySelector(`.g-viewer-selector-item img[src="${imageSrc}"]`).parentElement
        }
        if (activeImage && activeItem) {
            this.cleanActive()
            activeImage.classList.add('active')
            activeItem.classList.add('active')
        }
    }

    cleanActive(){
        for(let img of this.#viewer.querySelectorAll('.g-viewer-preview img'))
            img.classList.remove('active')
        for(let item of this.#viewer.querySelectorAll('.g-viewer-selector-item'))
            item.classList.remove('active')
    }

    static loadAllGalleryViewers(){
        const gViewerElems = document.querySelectorAll('.g-viewer');
        for(let gViewer of gViewerElems)
            this.VIEWERS.push(new GalleryViewer(gViewer))
    }
}